import styled, { css } from 'styled-components';
import type { ButtonProps } from './Dropdown.typed';

export const Button = styled.button<ButtonProps>`
  font-size: 14px;
  line-height: 24px;
  color: ${({ theme }) => theme.brand.primary.base};

  svg {
    margin-left: 0.25rem;
    transform: rotate(0);

    ${({ isOpen }) =>
      isOpen &&
      css`
        transform: rotate(180deg);
      `}
  }
`;

export const Dropdown = styled.div`
  background: #ffffff;
  box-shadow: ${({ theme }) => theme.shadow.primary};
  border-radius: ${({ theme }) => theme.borderRadius.s};
  overflow: hidden;
  min-width: 200px;
  z-index: 9999;
`;
